import { eventLog, log } from "../../log";
import { uuid } from "../../Common";
import { States } from "./model";
import { callAnswer, callHold, callTerminate } from "./actions";
export class CallImpl {
    constructor(parent, direction, remoteEndpoint, id) {
        this.parent = parent;
        this.eventHandlers = {};
        this.id = id || uuid();
        this.direction = direction;
        this.remoteEndpoint = remoteEndpoint;
        this.holdStatus = {
            local: false,
            remote: false,
        };
        this.holdPromise = {};
        const context = parent.getCallContext(remoteEndpoint.username);
        this.options = context.options;
        this.eventHandlers = context.options.eventHandlers || this.eventHandlers;
    }
    answer(options) {
        if (this.direction === "incoming") {
            this.options = options;
            this.eventHandlers = options.eventHandlers || this.eventHandlers;
            this.parent.getStore().dispatch(callAnswer({ callId: this.id }));
        }
    }
    hold() {
        if (this.holdStatus.local || this.holdStatus.remote) {
            return Promise.resolve();
        }
        this.holdPromise.promise = new Promise((resolve, reject) => {
            this.holdPromise.resolve = resolve;
            this.holdPromise.reject = reject;
        });
        this.parent.getStore().dispatch(callHold({ callId: this.id, hold: true }));
        return this.holdPromise.promise;
    }
    unhold() {
        if (!this.holdStatus.local) {
            return Promise.reject(new Error("hold is not local"));
        }
        this.holdPromise.promise = new Promise((resolve, reject) => {
            this.holdPromise.resolve = resolve;
            this.holdPromise.reject = reject;
        });
        this.parent.getStore().dispatch(callHold({ callId: this.id, hold: false }));
        return this.holdPromise.promise;
    }
    isOnHold() {
        return this.holdStatus;
    }
    isEstablished() {
        return this.pointer === States.ESTABLISHED;
    }
    isInProgress() {
        return this.pointer === States.RINGING || this.pointer === States.ANSWER;
    }
    on(eventId, handler) {
        this.setEventHandler(eventId, handler);
    }
    terminate(reason) {
        this.parent.getStore().dispatch(callTerminate({ reason, callId: this.id }));
    }
    // end of ISession
    sendEvent(eventId, eventData) {
        eventLog.debug(`call session event ${eventId}`, eventData);
        if (this.hasEventHandler(eventId)) {
            try {
                this.getEventHandler(eventId)(eventData);
            }
            catch (error) {
                log.error(`error while executing call session
                 ${eventId} handler`, error);
            }
        }
    }
    getEventHandler(eventId) {
        return this.eventHandlers[eventId];
    }
    hasEventHandler(eventId) {
        return !!this.eventHandlers[eventId];
    }
    setEventHandler(eventId, handler) {
        this.eventHandlers[eventId] = handler;
    }
}
//# sourceMappingURL=index.js.map